define([
	"dojo/_base/declare",
	"csi/heading/Renderer",
	"csi/locale",
	"csi/model/image",
], function(declare, Renderer, locale, {DEFAULT_IMAGE_LABEL, getImageLabeledKeys, getImageLabelEnumValue}) {

	return declare(Renderer, {
		/**
		 * @override
		 * Return comma-separated labels for image
		 */
		toValue(ctx, h) {
			const imgUrl = ctx.getNode().$URL;
			const parent = ctx.getParent();

			return getImageLabeledKeys(parent, null, true)
				.filter((key) => imgUrl == parent.Images[key])
				.map((key) => (key == DEFAULT_IMAGE_LABEL) ? locale.resource("DefaultImage") : locale.getEnumName(getImageLabelEnumValue(parent, key)))
				.join(", ");
		}
	});
});
